import React from 'react';
import { useTranslation } from 'react-i18next';

type LoadingDotsProps = {
  image?: string;
  label?: string;
};

function LoadingDots({ image, label = '' }: LoadingDotsProps): JSX.Element {
  const { t } = useTranslation();
  const accessibleLabel = label || t('alt:Loading');

  return (
    <div
      aria-busy="true"
      aria-label={accessibleLabel}
      aria-live="polite"
      className="loading-dots"
      role="status"
    >
      {image && (
        <img alt="" aria-hidden="true" className="loading-dots__img" src={image} />
      )}
      {label && <p className="loading-dots__text">{label}</p>}
      <div aria-hidden="true" className="loading-dots__loader">
        <div className="loading-dots__dot-one" />
        <div className="loading-dots__dot-two" />
        <div className="loading-dots__dot-three" />
      </div>
    </div>
  );
}

export default LoadingDots;
